module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAFiUAABYlAUlSJPAAAADiSURBVDhPpZK9CsIwHMTzGL6HDk6Ogrubr+CsOPQlCq5+OzoXHDr4sQhqnRRRJwWXLhbFRc9/miaaKJTicUNJ7pdcmjAk1P/A3cfGxrQEtwCvBn8ejUvpwMpCh6HB0GJoMzRDOxlcj1FAA2hVinYZegz90PRBJniQQnAQKQls63xCRT8tmGFOBEPg+YCT5h1+AmQap6rnkQSCPW9CNnLKBNByi6oELjut+rcFMCtLQOwQC7x3UGcwcsoEaGcgJftLQpNE9yDkWbyYedNZ3E5RwARI9JbWNsZFuHksK3FvKVbAC/IrVYExZV5aAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./ClientApp/images/node-icons/external_price-node.png
// module id = 984
// module chunks = 0